import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewChild,
  ElementRef,
} from "@angular/core";

import { IOption } from "ng-select";
import { EvsProductService } from "../../common/services/EvsProduct.service";

declare var $: any;

@Component({
  selector: "app-filter-product-variants",
  templateUrl: "./filter-product-variants.component.html",
  styleUrls: ["./filter-product-variants.component.css"],
  providers: [EvsProductService],
})
export class FilterProductVariantsComponent implements OnInit {
  @Output() selectedVariantId = new EventEmitter<any>();
  @Output() selectedVariantLabel = new EventEmitter<any>();
  @Input() productId: any;
  @Input() variant: any;
  listProductVariants: Array<IOption> = [];
  limitVariant: number = 10;
  offsetVariant: number = 0;
  searchVariantQuery = "";
  tmpCountBottom = 0;
  sltVariantId: any = null;
  tmp: any;

  constructor(private productService: EvsProductService) {}

  ngOnInit() {
    if (this.productId) {
      this.getListProductVariant(this.productId).then(() => {
        if (this.variant) {
          if (!this.currentObj) {
            this.currentObj = {
              value: this.variant.id,
              label: this.variant.extra,
            };
          }
          if (
            this.listProductVariants
              .map((gg) => gg.value)
              .indexOf(this.variant.id) == -1
          ) {
            let tmp = {
              value: this.variant.id,
              label: this.variant.extra,
            };
            let arrTmp = this.listProductVariants;
            arrTmp.push(tmp);
            this.listProductVariants = arrTmp;
          }
        }
      });
    }

    // when scroll to bottom of div to load more
    document.addEventListener(
      "scroll",
      (event) => {
        event.stopPropagation();
        let ele = <HTMLElement>event.target;
        if (ele) {
          let ele2 = <HTMLElement>ele.parentElement;
          if (ele2) {
            let ele3 = <HTMLElement>ele2.parentElement;
            if (ele3) {
              let ele4 = <HTMLElement>ele3.parentElement;
              if (ele4) {
                if (
                  ele.className === "options" &&
                  ele4.id == "drp-list-product-variants"
                ) {
                  if (ele.scrollTop === ele.scrollHeight - ele.clientHeight) {
                    this.tmpCountBottom += 1;
                    this.offsetVariant =
                      this.tmpCountBottom * this.limitVariant;
                    this.tmp = this.listProductVariants;

                    this.getListProductVariant(
                      this.productId,
                      this.searchVariantQuery
                    ).then(() => {
                      let tmp2: any;
                      if (this.tmp) {
                        tmp2 = this.tmp.concat(this.listProductVariants);
                        let flagCount = 0;
                        if (this.variant) {
                          if (
                            tmp2
                              .map((gg) => gg.value)
                              .indexOf(this.variant.id) !=
                            tmp2
                              .map((gg) => gg.value)
                              .lastIndexOf(this.variant.id)
                          ) {
                            let index = tmp2
                              .map((gg) => gg.value)
                              .lastIndexOf(this.variant.id);
                            console.log(index);
                            tmp2.splice(index, 1);
                          }
                        }
                      }
                      this.listProductVariants = tmp2;
                    });
                  }
                }
              }
            }
          }
        }
      },
      true
    );

    // call api when stop typing
    var delay = (function () {
      var timer: any = 0;
      return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
      };
    })();

    // when search
    document.addEventListener("keyup", (event) => {
      event.stopPropagation();
      let ele = <HTMLElement>event.target;
      if (ele) {
        let ele2 = <HTMLElement>ele.parentElement;
        if (ele2) {
          let ele3 = <HTMLElement>ele2.parentElement;
          if (ele3) {
            let ele4 = <HTMLElement>ele3.parentElement;
            if (ele4) {
              let ele5 = <HTMLElement>ele4.parentElement;
              if (ele5) {
                if (
                  ele.parentElement.className == "filter" &&
                  ele5.id == "drp-list-product-variants"
                ) {
                  let inputEle = <HTMLInputElement>event.target;
                  let searchQuery = inputEle.value;

                  this.tmpCountBottom = 0;
                  this.offsetVariant = 0;
                  this.listProductVariants = null;

                  delay(() => {
                    this.searchVariantQuery = searchQuery;
                    this.getListProductVariant(
                      this.productId,
                      this.searchVariantQuery
                    ).then(() => {
                      let tmp = this.listProductVariants;

                      if (tmp && this.currentObj) {
                        if (
                          !tmp.some((e) => e.value == this.currentObj.value)
                        ) {
                          tmp.push(this.currentObj);
                        }
                      }

                      this.listProductVariants = tmp;
                    });
                  }, 500);
                }
              }
            }
          }
        }
      }
    });
  }

  // get list product variant
  getListProductVariant(product_id: any = null, query: any = null) {
    let opt: any;
    if (query) {
      opt = {
        limit: this.limitVariant,
        offset: this.offsetVariant,
        extra: query,
      };
    } else {
      opt = {
        limit: this.limitVariant,
        offset: this.offsetVariant,
      };
    }

    return this.productService
      .getListVariant(product_id, opt)
      .toPromise()
      .then((res) => {
        if (!res.error && res.data.count.count) {
          let arrTmp = [];
          res.data.products.forEach((variant) => {
            let item = {
              value: variant.id.toString(),
              label: variant.extra,
            };

            if (this.currentObj) {
              if (item.value != this.currentObj.value) {
                arrTmp.push(item);
              }
            } else {
              arrTmp.push(item);
            }
          });
          this.listProductVariants = arrTmp;
        }
      });
  }

  // when select option
  currentObj: any;
  selectedProductVariant(e) {
    this.sltVariantId = e.value;
    this.selectedVariantId.emit(this.sltVariantId);
    this.selectedVariantLabel.emit(e.label);

    this.currentObj = {
      value: e.value,
      label: e.label,
    };
  }

  // when deselect option
  deselectedProductVariant(e) {
    this.sltVariantId = null;
    this.selectedVariantId.emit(this.sltVariantId);
    this.selectedVariantLabel.emit(null);
  }

  // when open select box
  opened() {
    this.tmpCountBottom = 0;
    this.offsetVariant = 0;
    this.listProductVariants = null;
    this.searchVariantQuery = "";

    this.getListProductVariant(this.productId).then(() => {
      let tmp = this.listProductVariants;

      if (this.currentObj) {
        if (!tmp.some((e) => e.value == this.currentObj.value)) {
          tmp.push(this.currentObj);
        }
      }

      if (this.variant) {
        if (tmp.map((gg) => gg.value).indexOf(this.variant.id) == -1) {
          let obj = {
            value: this.variant.id,
            label: this.variant.extra,
          };
          tmp.push(obj);
        }
      }

      this.listProductVariants = tmp;
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/layout/filter-product-variants/filter-product-variants.component.ts